module.exports = __webpack_public_path__ + "static/media/logo.19f181f4.svg";